module.exports = __webpack_public_path__ + "static/media/English_US_Drew BG-48.058ab800.png";